<div class="flex flex-col items-center justify-center  px-7 text-center">
  <div class="img-holder">
    <img class="img-fluid" [src]="assetPath + iconSource">
  </div>
  <h6 class="font-bold text-blue-500 mt-4 ">{{title}}</h6>
  <p class="text-muted mt-2 text-small text-center">
    {{description}}
  </p>
</div>
